export default __webpack_public_path__ + "static/media/main_header.560bcb86.png";